document.addEventListener('DOMContentLoaded', () => {
  normalizeProductPageHeadings();
  markBottleOptionButtons();
});

function headingText(heading) {
  return heading.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, '').trim();
}

function removeEmptyHeadings() {
  document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
    if (!headingText(heading)) heading.remove();
  });
}

function normalizeProductPageHeadings() {
  removeEmptyHeadings();
  const mainTitle = document.querySelector('h1');
  const mainTitleText = mainTitle ? mainTitle.textContent.replace(/\s+/g, ' ').trim() : '';

  document.querySelectorAll('h1').forEach((heading) => {
    if (heading === mainTitle) return;
    if (mainTitle && heading.textContent.replace(/\s+/g, ' ').trim() === mainTitleText) {
      replaceHeadingTag(heading, 'p', 'product-main-title-duplicate');
      return;
    }
    replaceHeadingTag(heading, 'h2');
  });

  document.querySelectorAll('h2, h3, h4, h5, h6').forEach((wrapper) => {
    wrapper.querySelectorAll(':scope > h1').forEach((nestedHeading) => {
      replaceHeadingTag(nestedHeading, 'h2');
    });
  });

  document
    .querySelectorAll('.description-accordion .collapsible__content h1, .description-accordion .collapsible__content h2')
    .forEach((heading) => {
      replaceHeadingTag(heading, 'h3');
    });

  document.querySelectorAll('.description-accordion .collapsible__heading').forEach((heading) => {
    if (heading.tagName !== 'H2') {
      replaceHeadingTag(heading, 'h2');
    }
  });

  removeEmptyHeadings();
}

function markBottleOptionButtons() {
  document.querySelectorAll('.product-bottle-options__list--item').forEach((item) => {
    if (item.querySelector('.product-bottle-options__pick')) return;
    const title = item.querySelector('.product-bottle-options__list--item-title');
    const name = title ? title.textContent.replace(/\s+/g, ' ').trim() : 'Pack option';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-bottle-options__pick';
    button.setAttribute('aria-current', item.classList.contains('active') ? 'true' : 'false');

    const label = document.createElement('span');
    label.className = 'visually-hidden';
    label.textContent = name;

    const state = document.createElement('span');
    state.className = 'product-bottle-options__state';
    state.textContent = 'Selected';

    button.append(label, state);
    item.append(button);
  });
}

function syncBottleOptionState(item) {
  const list = item.closest('.product-bottle-options__list');
  if (!list) return;
  list.querySelectorAll('.product-bottle-options__pick').forEach((button) => {
    const option = button.closest('.product-bottle-options__list--item');
    button.setAttribute('aria-current', option && option.classList.contains('active') ? 'true' : 'false');
  });
}

document.addEventListener('click', (event) => {
  const item = event.target.closest('.product-bottle-options__list--item');
  if (!item) return;
  syncBottleOptionState(item);
});

function replaceHeadingTag(node, tagName, className) {
  if (!node || node.tagName.toLowerCase() === tagName.toLowerCase()) return;
  const replacement = document.createElement(tagName);
  replacement.innerHTML = node.innerHTML;
  Array.from(node.attributes).forEach((attr) => {
    replacement.setAttribute(attr.name, attr.value);
  });
  if (className) {
    replacement.classList.add(className);
  }
  node.replaceWith(replacement);
}
